<template>
  <ConfigErrorBoundary>
    <FileCompressor
      :config="compressorConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileCompressor from './FileCompressor.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateCompressorConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const compressorConfig = parseAndValidateCompressorConfig('gif-compressor', 'GIF Compressor');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[GIF Compressor] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[GIF Compressor] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[GIF Compressor] Batch cleared');
}

function handleError(error: Error) {
  console.error('[GIF Compressor] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[GIF Compressor] Credits updated:', credits);
}
</script>
